import { render, staticRenderFns } from "./AddNewBriefcaseFolderDialog.vue?vue&type=template&id=de0b4e04&scoped=true"
import script from "./AddNewBriefcaseFolderDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddNewBriefcaseFolderDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0b4e04",
  null
  
)

export default component.exports